import React from "react";
function RoundedCornerIconAtm(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0L40 40L0 40C21.9059 40 39.699 22.1428 39.9962 -1.65201e-10L40 0Z",
    fill: color
  }));
}
export default RoundedCornerIconAtm;